import { CaretRightOutlined } from "@ant-design/icons";

import Sidebar from "./Sidebar/Sidebar";
import TableAllContracts from "./TableAllContracts/TableAllContracts";
import TableReadyToSend from "./TableReadyToSend/TableReadyToSend";
import TableFundraisingLink from "./TableFundraisingLink/TableFundraisingLink";

import useOverview from "../../Hooks/useOverview/useOverview";

import { IOverview } from "./IOverview";

import "./Overview.scss";

const Overview = ({
  baseURL,
  baseURLExternal,
  translations,
  userEmail,
  userId,
  userIdInstitution,
  placementAgents,
  clientId,
  language,
  moduleRole
}: IOverview) => {

	const {
		contractView, 
		selectedInstitutionId,
		setSelectedInstitutionId,
		selectedVehicleId,
		setSelectedVehicleId,
		isSidebarCollapsed,
		setIsSidebarCollapsed,
		setContractView,
	}  = useOverview();

  return (
    <div className={`overview ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
	  <Sidebar 
		userId={userId}
		userIdInstitution={userIdInstitution}
		translations={translations}
		placementAgents={placementAgents}
		selectedInstitutionId={selectedInstitutionId}
		setSelectedInstitutionId={setSelectedInstitutionId}
		setSelectedVehicleId={setSelectedVehicleId}
		isCollapsed={isSidebarCollapsed}
		onToggleCollapse={() => setIsSidebarCollapsed(current => !current)}
		userEmail={userEmail}
		language={language}
	  />
	  <div className="overview-tables">
		<div className="overview-header">
			<h2><span><CaretRightOutlined /></span>{translations.welcome} Bookbuilding</h2>
			<div className="overview-table-selector">
				<button onClick={() => setContractView('all')} className={`${contractView === 'all' ? 'selected-btn' : ''}`}>{translations.allContracts}</button>
				{userIdInstitution === 536 && <button onClick={() => setContractView('readyToSend')} className={`${contractView === 'readyToSend' ? 'selected-btn' : ''} inrevision-btn`}>{translations.readyToSend}</button>}
				{userIdInstitution === 536 && <button onClick={() => setContractView('fundraisingLink')} className={`${contractView === 'fundraisingLink' ? 'selected-btn' : ''} inrevision-btn`}>DC connections</button>}
			</div>
		</div>
		{contractView === 'all' && (
			<TableAllContracts
				baseURL={baseURL}
				baseURLExternal={baseURLExternal}
				translations={translations}
				userIdInstitution={userIdInstitution}
				selectedInstitutionId={selectedInstitutionId}
				selectedVehicleId={selectedVehicleId}
				clientId={clientId}
				language={language}
				moduleRole={moduleRole}
			/>
		)}
		{(userIdInstitution === 536 && contractView === 'readyToSend') && 
			<TableReadyToSend
				baseURL={baseURL}
				baseURLExternal={baseURLExternal}
				translations={translations}
				clientId={clientId}
				language={language}
				moduleRole={moduleRole}
			/>
		} 
		{(userIdInstitution === 536 && contractView === 'fundraisingLink') &&
			<TableFundraisingLink baseURL={baseURL} clientId={clientId} language={language} moduleRole={moduleRole} />
		}
		</div>
    </div>
  );
};

export default Overview;
